import { useEffect } from 'react'

import { useMutationPostRegisterFCMToken } from '@/api/notifications/mutations'
import { pushNotificationService } from '@/lib/push-notifications/service'
import { getDevice } from '@/utils/get-device'
import { isMobileDevice } from '@/utils/is-mobile-device'
import { useAuth } from './useAuth'
import { Logger } from '@/lib/logger'

const logger = new Logger('PushNotifications')

export const usePushNotifications = () => {
  const { isAuthenticated } = useAuth()
  const { mutateAsync: registerToken } = useMutationPostRegisterFCMToken({
    onSuccess: () => {
      logger.info('Mutation de registro do Token executada com sucesso!')
    },
    onError: (error) => {
      logger.info('Erro na mutation de registro do Token!: ', JSON.stringify(error))
    },
  })

  useEffect(() => {
    if (!isAuthenticated) return

    const init = async () => {
      await pushNotificationService.initialize({
        onRegistration: [
          async (token: string) => {
            const device = await getDevice()
            if (!isMobileDevice(device)) return
            registerToken({ token, device_type: device.platform })
          },
        ],
        onActionPerformed: [],
        onReceived: [],
        onRegistrationError: [],
      })
    }

    init()

    return () => {
      pushNotificationService.unregister()
    }
  }, [isAuthenticated])
}
